import dayjs from 'dayjs';

export const startOfLegacyMondayWeek = (value: any) => {
    const date = dayjs(value).startOf('day');
    const daysSinceMonday = (date.day() + 6) % 7;
    return date.subtract(daysSinceMonday, 'day');
};

export const endOfLegacyMondayWeek = (value: any) =>
    startOfLegacyMondayWeek(value).add(6, 'day').endOf('day');

export const isSameLegacyMondayWeek = (left: any, right: any) =>
    startOfLegacyMondayWeek(left).isSame(startOfLegacyMondayWeek(right), 'day');

const KOREAN_WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토'];

const getWeeklyScheduleWeekday = (scheduleDay: any) => String(scheduleDay?.daysOfWeek || '').trim();

export const orderLegacyWeeklyScheduleDays = (weeklySchedules: any[]) =>
    [...weeklySchedules].sort((left, right) => {
        const leftDate = dayjs(left?.dateFormat);
        const rightDate = dayjs(right?.dateFormat);

        if (!leftDate.isValid() || !rightDate.isValid()) return 0;
        return leftDate.valueOf() - rightDate.valueOf();
    });

export const normalizeLegacyMondayWeekScheduleDays = (
    currentSundayWeekSchedules: any[],
    value: any,
    followingSundayWeekSchedules: any[] = []
) => {
    const weekStart = startOfLegacyMondayWeek(value);
    return Array.from({ length: 7 }, (_, dayIndex) => {
        const date = weekStart.add(dayIndex, 'day');
        const dateKey = date.format('YYYY-MM-DD');
        const weekday = KOREAN_WEEKDAYS[date.day()];
        const sourceSchedules = dayIndex === 6 ? followingSundayWeekSchedules : currentSundayWeekSchedules;
        const fallbackIndex = dayIndex === 6 ? 0 : dayIndex + 1;
        const hasWeekdayLabels = sourceSchedules.some((sourceDay) => getWeeklyScheduleWeekday(sourceDay));
        const scheduleDay = hasWeekdayLabels
            ? sourceSchedules.find((sourceDay) => getWeeklyScheduleWeekday(sourceDay) === weekday)
            : sourceSchedules[fallbackIndex];

        return scheduleDay
            ? {
                  ...scheduleDay,
                  dateFormat: dateKey,
                  day: `${date.date()}일`,
                  daysOfWeek: weekday,
              }
            : {
                  dateFormat: dateKey,
                  day: `${date.date()}일`,
                  daysOfWeek: weekday,
                  schedules: Array.from({ length: 24 }, () => []),
              };
    });
};

export const countLegacyWeeklyScheduleItems = (weeklySchedules: any[]) =>
    weeklySchedules.reduce(
        (weekTotal, scheduleDay) =>
            weekTotal +
            (Array.isArray(scheduleDay?.schedules)
                ? scheduleDay.schedules.reduce(
                      (dayTotal: number, hourlySchedules: any) =>
                          dayTotal + (Array.isArray(hourlySchedules) ? hourlySchedules.length : 0),
                      0
                  )
                : 0),
        0
    );
